<template>

  <section class="bulk-issue-result">

    <div
      v-if="isUnknownResult"
      class="bulk-issue-result__notice"
    >
       Chưa xác nhận được kết quả cuối. Job có thể vẫn đang xử lý nền.
    </div>
     <template v-else
      >
      <div class="bulk-issue-result__summary">

        <div class="bulk-issue-result__metric">
           <span>Thành công</span> <strong>{{ result.succeeded.length }}</strong
          >
        </div>

        <div class="bulk-issue-result__metric bulk-issue-result__metric--danger">
           <span>Thất bại</span> <strong>{{ result.failed.length }}</strong
          >
        </div>

        <div class="bulk-issue-result__metric">
           <span>Bỏ qua</span> <strong>{{ result.skipped }}</strong
          >
        </div>

      </div>
      <b-table
        v-if="result.failed.length > 0"
        :items="result.failed"
        :fields="failedFields"
        small
        bordered
        responsive
        show-empty
        class="bulk-issue-table"
        > <template #cell(invoiceNo)="{ item }"
          >
          <div class="bulk-issue-result__invoice-cell">
             <strong>{{ item.invoiceNo }}</strong
            > <small>{{ item.salesInvoiceId }}</small
            >
          </div>
           </template
        > <template #cell(code)="{ item }"
          > <span class="bulk-issue-table__reason-pill"
            > {{ getReasonLabel(item.code || item.reasonCode) }} </span
          > </template
        > <template #cell(message)="{ item }"
          >{{ item.message || 'Không có mô tả chi tiết từ hệ thống.' }}</template
        > </b-table
      > </template
    >
  </section>

</template>

<script>
  import { getReasonLabel } from '../utils/bulkIssue.utils'

  export default {
    name: 'BulkIssueResultState',
    props: {
      result: {
        type: Object,
        default: () => ({ succeeded: [], failed: [], skipped: 0 }),
      },
      isUnknownResult: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      failedFields() {
        return [
          { key: 'invoiceNo', label: 'Số HĐ' },
          { key: 'code', label: 'Lý do' },
          { key: 'message', label: 'Chi tiết' },
        ]
      },
    },
    methods: {
      getReasonLabel,
    },
  }
</script>

<style scoped>
  .bulk-issue-result {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
  }

  .bulk-issue-result__notice {
    padding: 0.85rem 1rem;
    border: 1px solid #f0ddae;
    border-radius: 12px;
    background: #fffaf0;
    color: #6e5a2f;
    font-size: 0.84rem;
    line-height: 1.45;
  }

  .bulk-issue-result__summary {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .bulk-issue-result__metric {
    padding: 0.8rem 0.9rem;
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
  }

  .bulk-issue-result__metric--danger {
    background: #fff6f7;
    border-color: #efc7cd;
  }

  .bulk-issue-result__metric span {
    display: block;
    color: #748093;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .bulk-issue-result__metric strong {
    display: block;
    margin-top: 0.2rem;
    color: #1f2a3d;
    font-size: 1.05rem;
    font-weight: 700;
  }

  .bulk-issue-table {
    margin-bottom: 0;
  }

  .bulk-issue-result__invoice-cell {
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
  }

  .bulk-issue-result__invoice-cell strong {
    color: #1f2a3d;
    font-size: 0.9rem;
    font-weight: 700;
  }

  .bulk-issue-result__invoice-cell small {
    color: #7c8798;
    font-size: 0.72rem;
    word-break: break-all;
  }

  .bulk-issue-table__reason-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.26rem 0.58rem;
    border-radius: 999px;
    background: #fff1f2;
    color: #c94c5f;
    font-size: 0.74rem;
    font-weight: 700;
  }

  @media (max-width: 575.98px) {
    .bulk-issue-result__summary {
      grid-template-columns: 1fr;
    }
  }
</style>
